import React, { useEffect, useMemo, useState } from 'react';
import "./eventDetails.css";
import { useParams } from 'react-router';
import axios from 'axios';
import C2wImagePreview from '../../../../common/global/imagePreview/imagePreview';
import eventData from "../../../../../src/data/events.json"

function C2wEventsDetails() {
    const { slug } = useParams();
    const [imgPreFlag, setImgPreFlag] = useState(false)
    const [activeIndex, setActiveIndex] = useState(-1)

    // const fetchData = async () => {
    //     try {
    //         const data = await axios.get("/data/events.json")
    //         const event = data.data?.events?.find(
    //             (c) => c.slug === slug
    //         );
    //         setEvent(event)
    //         console.log(event)
    //     } catch (err) {
    //         console.log(err)
    //     }
    // }

    const event = useMemo(() => {
        return eventData?.events?.find((c) => c.slug === slug);
    }, [slug]);

    // useEffect(() => {
    //     fetchData()
    // }, [slug]);

    // Function to generate random size and position styles
    const generateRandomStyle = () => {
        const sizes = ["span 1", "span 2", "span 3"]; // Grid span options
        const randomSize = sizes[Math.floor(Math.random() * sizes.length)];

        return {
            gridColumn: randomSize,
            gridRow: randomSize,
            transform: `rotate(${Math.random() * 10 - 5}deg)`, // Slight rotation
        };
    };
    return (
        <div className='C2wEventsDetails'>
            <div className='C2wEventsDetails_container'>
                <div className="gallery-container">
                    <h1 className="gallery-title">{event?.name}</h1>
                    <hr className='C2wEvent_horizontalline'></hr>
                    <div className="grid-container">
                        {event && event.imagesData.map((image, index) => (
                            <div key={image.id} className="grid-image" onClick={() => {
                                setImgPreFlag(true)
                                setActiveIndex(index)
                            }}>
                                <img src={image.src} alt={image.id} />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            {
              imgPreFlag &&  <C2wImagePreview activeIndex={activeIndex} imagesData={event?.imagesData} setImgPreFlag={setImgPreFlag}/>
            }
        </div>
    )
}

export default C2wEventsDetails
